import PropTypes from "prop-types";

import { Grid, DialogTitle, Typography, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

export default function DialogHeader(props) {
  const { title, subtitle, onClose } = props;

  return (
    <DialogTitle>
      <Grid container justifyContent={title ? "space-between" : "flex-end"} alignItems="center">
        {title && (
          <Grid item xs>
            <Typography variant="h6" component="div">
              {title}
            </Typography>
          </Grid>
        )}

        <Grid item xs={1}>
          <IconButton aria-label="delete" onClick={onClose}>
            <Close color="primary" />
          </IconButton>
        </Grid>
      </Grid>

      {subtitle && (
        <Typography variant="subtitle1" gutterBottom component="div">
          {subtitle}
        </Typography>
      )}
    </DialogTitle>
  );
}

DialogHeader.propTypes = {
  onClose: PropTypes.func,
};
